import { render, staticRenderFns } from "./m-filter-latest.vue?vue&type=template&id=651b2a8d&scoped=true"
import script from "./m-filter-latest.vue?vue&type=script&lang=js"
export * from "./m-filter-latest.vue?vue&type=script&lang=js"
import style0 from "./m-filter-latest.vue?vue&type=style&index=0&id=651b2a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b2a8d",
  null
  
)

export default component.exports